import { BACKEND, DOCS_FORM_NAME_TO_AI_CORE_FORM_NAME } from "core/consts";
import transport from "core/model/api/transport";
import {
  DocsFormName,
  DocsFormStartResponse,
  DocsFormStatusResponse,
  ExtractOCRResult,
  ExtractOCRStatusResponse,
  FileCategory,
  FileState,
} from "core/types";

export default {
  docs: {
    fill: async ({
      careseekerId,
      formName,
      patientId,
    }: {
      careseekerId: number;
      patientId: number;
      formName: DocsFormName;
    }): Promise<DocsFormStatusResponse> => {
      return transport.get<DocsFormStatusResponse>({
        backend: BACKEND.AI_CORE,
        route: `/v1/docs/${careseekerId}/form/status/${patientId}/${DOCS_FORM_NAME_TO_AI_CORE_FORM_NAME[formName]}`,
      });
    },
    start: async ({
      careseekerId,
      formName,
      patientId,
    }: {
      careseekerId: number;
      patientId: number;
      formName: DocsFormName;
    }): Promise<DocsFormStartResponse> => {
      return transport.post<DocsFormStartResponse>({
        backend: BACKEND.AI_CORE,
        body: {
          careseeker_id: careseekerId,
          form_id: DOCS_FORM_NAME_TO_AI_CORE_FORM_NAME[formName],
          patient_id: patientId,
        },
        route: `/v1/docs/${careseekerId}/form/${patientId}/${DOCS_FORM_NAME_TO_AI_CORE_FORM_NAME[formName]}`,
      });
    },
  },
  extract: {
    delete: async ({
      careseekerId,
      fileId,
    }: {
      careseekerId?: number;
      fileId: FileState["id"];
    }): Promise<void> => {
      if (!careseekerId) {
        console.error("careseekerId is required to delete an extracted file");
        return;
      }
      return transport.del<void>({
        backend: BACKEND.AI_CORE,
        body: {},
        route: `/v1/extract/${careseekerId}/${fileId}`,
      });
    },
    ocr: async ({
      careseekerId,
      file,
      fileCategory,
      fileId,
      patientId,
    }: {
      file: File;
      patientId: number;
      careseekerId: number;
      fileId: FileState["id"];
      fileCategory: FileCategory;
    }): Promise<ExtractOCRResult> => {
      const formData = new FormData();

      formData.append("file", file);

      formData.append("patient_id", patientId.toString());
      formData.append("careseeker_id", careseekerId.toString());
      formData.append("file_category", String(fileCategory));
      formData.append("file_id", String(fileId));

      return transport.post<ExtractOCRResult>({
        backend: BACKEND.AI_CORE,
        body: formData,
        route: `/v1/extract/${careseekerId}/ocr/${patientId}/${fileId}`,
      });
    },
    ocrStatus: async ({
      careseekerId,
      patientId,
    }: {
      careseekerId: number;
      patientId: number;
    }): Promise<ExtractOCRStatusResponse> => {
      return transport.get<ExtractOCRStatusResponse>({
        backend: BACKEND.AI_CORE,
        route: `/v1/extract/${careseekerId}/ocr/status/${patientId}`,
      });
    },
  },
};
